import React from 'react';

const mediaQueriesPrefixes = {
  'Mobile Small': '--xss',
  Mobile: '--xs',
  Tablet: '--md',
  Laptop: '--lt',
  Desktop: '--lg',
  'Large Desktop': '--lgd',
  Global: '-',
};

export const StylesCustomizer =
  (Component) =>
  ({ styles, children, ...props }) => {
    if (!styles) return <Component />;

    const stylesObj = JSON.parse(styles);

    const getVariables = (styles) => {
      const output = {};
      Object.entries(styles).forEach(([device, stylesObject]) => {
        const prefix = mediaQueriesPrefixes[device];
        Object.entries(stylesObject).forEach(([styleKey, styleValue]) => {
          output[`${prefix}-${styleKey}`] = styleValue;
        });
      });
      return output;
    };

    const variables = getVariables(stylesObj);

    if (children) {
      return (
        <Component {...variables} {...props}>
          {children}
        </Component>
      );
    }
    return <Component {...variables} {...props} />;
  };

export default StylesCustomizer;
